import React from "react";
import Topmenu from "./Buttered_Topmenu";
import Photoline from "./Buttered_Photoline";
import BottomMenu from "./Buttered_BottomMenu";
import ButteredInstagram from "./Buttered_insta";
import { TransitionContainer } from "./animation/TransitionContainer";
import styled from "styled-components";
import ButteredRecommendation from "./Buttered_Recommendation";
import { MapPin, ArrowUpRight } from "lucide-react";
import en from "../../language/Eng_Aust.json";

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  text-align: left;
  margin-bottom: 8px;
  padding-left: 0;
  width: 90%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  color: #333;

  @media (max-width: 768px) {
    padding-left: 0;
    width: calc(100% - 32px);
  }
`;

const SubTitle = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  margin-bottom: 16px;
  padding-left: 0;
  width: 90%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  color: #888;

  @media (max-width: 768px) {
    padding-left: 0;
    width: calc(100% - 32px);
  }
`;

const Home: React.FC = () => {
  return (
    <HomePage>
      <TransitionContainer>
        {/*<Popup />*/}
        <Topmenu />
        <Photoline />
        <VisitCard
          href={en.home.links.directions}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={en.home.directions.ariaLabel}
        >
          <span className="icon"><MapPin size={24} aria-hidden="true" /></span>
          <span className="details"><strong>{en.home.directions.title}</strong><small>{en.home.directions.description}</small></span>
          <ArrowUpRight size={20} aria-hidden="true" />
        </VisitCard>
        <ButteredRecommendation />
        <Title>
          <i className="fi fi-brands-instagram" /> {en.home.instagram.title}
        </Title>
        <SubTitle>
          {en.home.instagram.description}
        </SubTitle>
        <ButteredInstagram />
        <BottomMenu />
      </TransitionContainer>
    </HomePage>
  );
};

export default Home;
const HomePage = styled.div`
  background: #faf8f5; color: #342e28;
  @media (max-width: 768px) {
    padding-bottom: calc(76px + env(safe-area-inset-bottom));
  }
`;
const VisitCard = styled.a`
  display: flex; align-items: center; gap: 12px; width: 90%; max-width: 1200px;
  box-sizing: border-box; margin: 20px auto 0; padding: 12px 16px; border: 1px solid #f4e5a5;
  border-radius: 18px; background: #fffbed; color: #342e28; text-decoration: none;
  .icon { background: #ffed91; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  strong { display: block; font-size: 14px; margin-bottom: 2px; }
  small { display: block; color: #7d7468; font-size: 13px; line-height: 1.5; }
  .details { min-width: 0; }
  transition: background .2s, border-color .2s;
  &:hover { background: #fff5cf; border-color: #e4c957; }
  > svg { margin-left: auto; flex-shrink: 0; }
  @media(max-width: 768px) { width: calc(100% - 32px); padding: 11px 12px; gap: 10px;
  }
`;
